// Пользовательские настройки (язык, тема, цвет) в localStorage.

import type { ThemeMode, UserPreferences } from '../types';
import { normalizeDashboardTheme } from '../theme';
import { normalizeLocale, resolveSystemLocale } from '../i18n';

export const PREFERENCES_STORAGE_KEY = 'socio-dashboard:user-preferences:v1';

export function safeStoredPreferences(): Partial<UserPreferences> {
  try {
    const stored = localStorage.getItem(PREFERENCES_STORAGE_KEY);
    return stored ? JSON.parse(stored) as Partial<UserPreferences> : {};
  } catch {
    return {};
  }
}

export function loadUserPreferences(): UserPreferences {
  const stored = safeStoredPreferences();
  const locale = normalizeLocale(stored.locale ?? resolveSystemLocale());
  const themeMode: ThemeMode = stored.themeMode === 'light' || stored.themeMode === 'dark' || stored.themeMode === 'system'
    ? stored.themeMode
    : 'system';
  return {
    locale,
    themeMode,
    lastPrimaryColor: normalizeDashboardTheme({
      primaryColor: stored.lastPrimaryColor,
      baseColor: stored.lastBaseColor,
    }).primaryColor,
  };
}

export const initialPreferences = loadUserPreferences();
